import type { IconSvgObject } from './types';

const GeorgianLariIcon: IconSvgObject = [
  ["path", { d: "M19 13.5C19 9.35786 15.6421 6 11.5 6C7.35786 6 4 9.35786 4 13.5C4 17.6421 7.35786 21 11.5 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13 3V12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 3V12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M4 21H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default GeorgianLariIcon;
